import { render, staticRenderFns } from "./CatalogImportDialog.vue?vue&type=template&id=0f90a5fb&scoped=true"
import script from "./CatalogImportDialog.vue?vue&type=script&lang=js"
export * from "./CatalogImportDialog.vue?vue&type=script&lang=js"
import style0 from "./CatalogImportDialog.vue?vue&type=style&index=0&id=0f90a5fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f90a5fb",
  null
  
)

export default component.exports